import { FormattedMessage } from 'react-intl'

import { cases } from '@subaio/utils'

import { Card } from 'components/Layout'

import { ApplicantType } from '../stepHandler'
import { MultipleApplicants } from './MultipleApplicants'
import { SingleApplicant } from './SingleApplicant'

type Props = {
	applicantType: ApplicantType
	otherApplicantName: string | undefined
	completedStep: 'signup' | 'budget'
}

export const NextSteps = ({ applicantType, otherApplicantName, completedStep }: Props) => (
	<Card title={<FormattedMessage id='flow.nextSteps.title' defaultMessage='Next steps' />}>
		{cases(applicantType, {
			[ApplicantType.MultipleApplicants]: (
				<MultipleApplicants completedStep={completedStep} otherApplicantName={otherApplicantName!} />
			),
			[ApplicantType.SingleApplicant]: <SingleApplicant completedStep={completedStep} />,
		})}
	</Card>
)
